import { productsApi } from "@redux/features/products/productsApi";
import { AppDispatch } from "@redux/hooks";
import {addQPO} from "@redux/features/purchases/purchasesSlice";
import { useHistory } from "react-router-dom";
import { Restocking } from "@/types/general";

export const getRestockingOrderQuantity = ({
    in_stock,
    min_inventory_quantity,
    min_purchase_quantity
}: Pick<Restocking.Root, "in_stock" | "min_inventory_quantity" | "min_purchase_quantity">) => {
    const stockDebt = Math.max(-in_stock, 0);
    const preferredQuantity = min_purchase_quantity + stockDebt;

    return preferredQuantity > 0
        ? preferredQuantity
        : Math.max(min_inventory_quantity - in_stock, 0);
};

export const useRestockingRedirect = (dispatch: AppDispatch) => {
    const history = useHistory();

    return (restocking: Restocking.Root) => {
        const quantity = getRestockingOrderQuantity(restocking);
        const result = dispatch(productsApi.endpoints.getProduct.initiate(restocking.product.id));

        result.unwrap().then((product) => {
            dispatch(addQPO({
                order: {product, quantity},
                meta: {
                    supplier: product.supplier
                }
            }));

            history.push("/dashboard/purchasing/new");
        })
        .finally(() => {
            result.unsubscribe();
        });
    }
}
